import { Material2050SearchOUT } from "api-client";

function ExternalEPDRow({ epd }: { epd: Material2050SearchOUT }) {
  return (
    <div>
      <p className="text-sm mb-1 text-indigo-800 font-normal">{epd.company}</p>
      <p className="text-base font-semibold group-hover/listItem:text-indigo-900 transition">
        {epd.name}
      </p>
    </div>
  );
}

export default ExternalEPDRow;
